import { UNIDENTIFIED_COVERAGE_LABEL } from '@/utils/coverage'

/**
 * Paleta do card "Ocupado sem identificação" (mockup M1-C).
 *
 * Usada pela grade V1 (`unidentified.vue`), pela legenda e pelo PDF da grade, e pelos cards
 * do Dashboard V2. NÃO é fonte única: alguns componentes (ex.: `Legend.vue`,
 * `ManagementDoctorTable.vue`, `CoverageModeSelector.vue`, `CoverageStatusFilterChips.vue`,
 * `CoveragePreviewSummary.vue`, `UnidentifiedCoverageCard.vue`) ainda repetem a hachura/cores
 * como literais — ao mudar a paleta, atualize-os também.
 */
export const UNIDENTIFIED_COVERAGE_COLORS = {
  /** Faixa clara do hachurado. */
  stripeLight: '#eeeef3',
  /** Faixa escura do hachurado (também o fundo sólido do card no PDF). */
  stripeDark: '#e1e1ea',
  /** Barra lateral, borda tracejada do avatar e borda da bolinha da legenda. */
  accent: '#68688d',
  /** Faixa escura da bolinha da legenda e borda da etiqueta do responsável. */
  border: '#bcbccd',
  /** Texto principal ("Ocupado", etiqueta). */
  text: '#34344f',
  /** Texto secundário ("s/ identificação"). */
  textSecondary: '#374151'
} as const

/** Hachurado 135° do card; `stripe` = largura de cada faixa em px (7 na semana, 5 na célula de mês). */
export const unidentifiedCoverageStripes = (stripe: number): string =>
  `repeating-linear-gradient(135deg, ${UNIDENTIFIED_COVERAGE_COLORS.stripeLight} 0 ${stripe}px, ${
    UNIDENTIFIED_COVERAGE_COLORS.stripeDark
  } ${stripe}px ${stripe * 2}px)`

/** Bolinha hachurada da legenda (mesmo desenho da legenda V1 em `Legend.vue`). */
export const UNIDENTIFIED_COVERAGE_LEGEND_SWATCH = `repeating-linear-gradient(135deg, ${UNIDENTIFIED_COVERAGE_COLORS.stripeLight} 0 3px, ${UNIDENTIFIED_COVERAGE_COLORS.border} 3px 5px)`

/** Cabeça do tooltip do card: rótulo, responsável e observação (V1 e cards do Dashboard V2). */
export const unidentifiedCoverageTooltipParts = (
  responsibleName: string | null | undefined,
  note: string | null | undefined
): string[] =>
  [UNIDENTIFIED_COVERAGE_LABEL, responsibleName && `Responsável: ${responsibleName}`, note].filter(
    (part): part is string => !!part
  )
